module.exports = ['indexes.rank_artist.m1', 'indexes.rank_artist.m2', 'indexes.rank_artist.m3', 'indexes.rank_artist.m5'];
